export default require("./Dragger.vue").default;
